/** Build a portal API path, appending the practitioner-preview
 *  `as_customer` param when previewing.
 *
 *  The backend's portal auth reads `as_customer` — the older `as_account`
 *  name predates the account→customer rename and silently 403s, so every
 *  portal fetch (summary + downloads) must go through this helper rather
 *  than hand-building the query string. */
export function portalPath(base: string, previewSlug?: string): string {
  if (!previewSlug) return base;
  return `${base}?as_customer=${encodeURIComponent(previewSlug)}`;
}
